module.exports = __webpack_public_path__ + "static/img/19.72598c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/eng/19.png
// module id = JqGk
// module chunks = 0